import { IonicButton } from 'ionic-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import z from 'zod/v4/classic/external.cjs';
import { INDIVIDUAL_APP } from '../../../../data/config';
import { RoleChangeDialogSchema } from '../../../../schemas/signInSchemas';
import { sendVerificationCodeToEmail } from '../../../../services/authentication/signup';
import DialogTitle from '../../../Dashboard/DialogTitle';

export function FirstDialogue({ onContinue }: { onContinue: () => void }) {
  const { getValues } =
    useFormContext<z.infer<typeof RoleChangeDialogSchema>>();

  const getTempPassword = () => {
    const { email, password } = getValues();
    if (!password) return onContinue();
    try {
      sendVerificationCodeToEmail(email);
      onContinue();
    } catch (error: any) {
      console.error(error.message);
    }
  };

  return (
    <div className="text-center space-y-6">
      {/* <DialogTitle /> */}
      {/* <img src="" alt="" className="w-[80%] h-auto" /> */}
      <div className="space-y-2">
        <DialogTitle className="text-text-dark-high font-semibold">
          We see you have an account, but not as a Store owner.
        </DialogTitle>
        <p className="text-text-dark-medium font-medium">
          {' '}
          Click continue to create a Store owner account
        </p>
      </div>
      <div className="flex items-center gap-4 flex-wrap w-full">
        <IonicButton
          onClick={getTempPassword}
          type="button"
          size="xlg"
          className="min-w-fit flex-1"
        >
          Continue
        </IonicButton>
        <a href={INDIVIDUAL_APP} className="block min-w-fit flex-1">
          <IonicButton
            type="button"
            size="xlg"
            variant="outline"
            className="w-full"
          >
            Go to my account
          </IonicButton>
        </a>
      </div>
    </div>
  );
}
